import { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { toast } from 'react-toastify'

import { createFile, getFiles } from '../../api/files'
import useApiCall from '../../api/useApiCall'

import FilesTable from './FilesTable/FilesTable'
import { IFile } from './files-model'

import styles from './data-sources.module.scss'

function DataSources() {
    const { t } = useTranslation()

    const [files, setFiles] = useState<IFile[]>([])

    const [, { refetch }] = useApiCall(getFiles, setFiles)

    useEffect(() => {
        let intervalId = 0

        if (files.some((file) => file.status === 'indexing')) {
            intervalId = setInterval(() => {
                refetch()
            }, 3000)
        } else if (intervalId) {
            clearInterval(intervalId)
        }

        return () => {
            clearInterval(intervalId)
        }
    }, [refetch, files])

    const inputRef = useRef<HTMLInputElement>(null)

    const handleUploadClick = () => {
        inputRef.current?.click()
    }

    const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
        try {
            const file = e.target.files?.[0]

            if (!file) {
                toast(`${t('no_file_chosen')}`, {
                    type: 'error',
                })

                return
            }

            const formData = new FormData()
            formData.append('file', file)

            await createFile(formData)
            refetch()

            e.target.value = ''
        } catch {
            toast(`${t('file_upload_failed')}`, {
                type: 'error',
            })
        }
    }

    return (
        <section className={styles.data_sources}>
            <h2 className={styles.data_sources__title}>
                {t('files')} ({files.length})
            </h2>

            <div className={styles.data_sources__content}>
                <button
                    onClick={handleUploadClick}
                    className={styles.data_sources__uploadButton}
                >
                    {t('upload_file')}
                </button>

                <input
                    ref={inputRef}
                    type="file"
                    hidden
                    onChange={handleFileChange}
                />

                <FilesTable files={files} refetch={refetch} />
            </div>
        </section>
    )
}

export default DataSources
